import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type Video1IconProps = CreateIconComponentProps;
export const Video1Icon: React.FC<Video1IconProps> = ({
  title = 'Video1',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m17 14.902 3.794-1.818a.865.865 0 0 1 .81.035.792.792 0 0 1 .396.68v5.403c0 .276-.15.533-.395.679a.865.865 0 0 1-.81.035L17 18.098v-3.196Z"
      clipRule="evenodd"
    />
    <rect
      width="15"
      height="9"
      x="2"
      y="12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      rx="1"
    />
    <circle cx="5.5" cy="6" r="3.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="13.5" cy="7.5" r="2" stroke="currentColor" strokeWidth="2" />
    <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M6 15h7" />
  </CreateIconComponent>
);
